import config from '../config';
import { DATE_LOCALE } from '../i18n/strings';

// The API resolves FileField/ImageField paths to absolute GCS URLs, but be
// defensive in case a relative path slips through.
export function mediaUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${config.apiBase}${path.startsWith('/') ? '' : '/'}${path}`;
}

export function formatDate(value, locale) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(DATE_LOCALE[locale] || 'fr-BE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(d);
}

// Per-brand accent, keyed by org slug. The data model has no brand-colour
// column, so we tint org blocks here. Calum -> terracotta; default -> group gold.
const ORG_ACCENTS = {
  calum: '#cf9a40',
  lamptwist: '#2b4138',
};
export function orgAccent(slug) {
  return ORG_ACCENTS[slug] || '#cf9a40';
}

// Fallback brand marks (in /public) used until a logo is uploaded in the hub.
const ORG_LOGO_FALLBACK = {
  calum: '/calum-logo.png',
  lamptwist: '/favicon.webp',
};

// Resolved org logo: the hub's uploaded logo if present, else a local brand mark.
export function orgLogo(org) {
  if (!org) return null;
  return mediaUrl(org.logo) || ORG_LOGO_FALLBACK[org.slug] || null;
}
